<template>
    <v-card class="workspace-dashboard__analytics-card" elevation="0">
        <div class="workspace-dashboard__section-head">
            <div>
                <div class="workspace-dashboard__section-kicker">Billing account analytics</div>
                <h2>Ownership signals</h2>
            </div>
            <span class="workspace-dashboard__section-note">Light and dark theme ready</span>
        </div>
        <div class="workspace-dashboard__analytics-highlights">
            <div
                v-for="group in analyticsGroups"
                :key="group.title"
                class="workspace-dashboard__analytics-summary"
            >
                <strong>{{ group.title }}</strong>
                <div class="workspace-dashboard__analytics-summary-grid">
                    <div v-for="item in group.items" :key="item.label">
                        <span>{{ item.label }}</span>
                        <strong>{{ item.value }}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="workspace-dashboard__analytics-grid">
            <div class="workspace-dashboard__chart-wrap">
                <div class="workspace-dashboard__chart-title">
                    <strong>Storage runway</strong>
                    <span>Remaining capacity and headroom</span>
                </div>
                <apexchart
                    type="radialBar"
                    height="220"
                    :options="storageChartOptions"
                    :series="storageChartSeries"
                />
            </div>
            <div class="workspace-dashboard__chart-wrap">
                <div class="workspace-dashboard__chart-title">
                    <strong>Upload activity</strong>
                    <span>Recent dataset creation by date</span>
                </div>
                <apexchart type="bar" height="220" :options="uploadChartOptions" :series="uploadChartSeries" />
            </div>
        </div>
    </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'DashboardUsageAnalytics',
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        analyticsHighlights: {
            type: Object,
            default: () => ({}),
        },
        storageChartOptions: {
            type: Object,
            default: () => ({}),
        },
        storageChartSeries: {
            type: Array,
            default: () => [],
        },
        uploadChartOptions: {
            type: Object,
            default: () => ({}),
        },
        uploadChartSeries: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        analyticsGroups() {
            return [
                {
                    title: 'Storage',
                    items: this.analyticsHighlights.storage || [],
                },
                {
                    title: 'Dataset Groups & Datasets',
                    items: this.analyticsHighlights.dataset || [],
                },
                {
                    title: 'Team metrics',
                    items: this.analyticsHighlights.workspace || [],
                },
            ];
        },
    },
};
</script>
